import Badge from "ds/components/Badge";
import { BadgeVariants } from "ds/components/Badge/types";
import { TemplateDeploymentState } from "types/generated";

type DeploymentStateConfig = {
  variant: BadgeVariants;
  text: string;
};

/** @public (Knip ignored - used in the file and exported for stories) */
export const DEPLOYMENT_STATES: Record<TemplateDeploymentState, DeploymentStateConfig> = {
  [TemplateDeploymentState.Destroying]: { variant: "orange", text: "Deleting" },
  [TemplateDeploymentState.DestroyingFailed]: { variant: "red", text: "Deleting Failed" },
  [TemplateDeploymentState.Discarded]: { variant: "gray", text: "Discarded" },
  [TemplateDeploymentState.Failure]: { variant: "red", text: "Failure" },
  [TemplateDeploymentState.Finished]: { variant: "green", text: "Success" },
  [TemplateDeploymentState.InProgress]: { variant: "blue", text: "In Progress" },
  // from UX perspective, "None" state is similar to "In Progress"
  [TemplateDeploymentState.None]: { variant: "blue", text: "In Progress" },
  [TemplateDeploymentState.Unconfirmed]: { variant: "yellow", text: "Unconfirmed" },
};

type DeploymentStateBadgeProps = {
  state: TemplateDeploymentState;
};

const DeploymentStateBadge = ({ state }: DeploymentStateBadgeProps) => {
  if (!DEPLOYMENT_STATES[state]) {
    return null;
  }

  return (
    <Badge
      variant={DEPLOYMENT_STATES[state].variant}
      type="strong"
      text={DEPLOYMENT_STATES[state].text}
    />
  );
};

export default DeploymentStateBadge;
